import qs from 'qs'
import '@/assets/style/global.css'
import '@classin/iconfont-classin/lib/iconfont.css'
import messageAlert from '@/api/message_alert.js'
import GET_serverTime from '@/api/get_servertime.js'
import App from './app.vue'
import '@/assets/js/flexible.js'
Vue.config.productionTip = false;

var appCreate = function(){
  var UILangList = ['zh-CN','zh-TW','en'];
  var localeLangType = window.browserVersion.language;
  if(UILangList.indexOf(localeLangType)<0){
    var UIMainLangType = localeLangType.split('-')[0];
    if(UILangList.indexOf(UIMainLangType)>=0){
      localeLangType = UIMainLangType;
    }else{
      if(UIMainLangType === 'zh'){
        localeLangType = 'zh-CN';
      }else{
        localeLangType = 'en';
      }
    }
  }
  var eeoI18nData = {
    locale: localeLangType,
    messages: {}
  };
  import(`@/lang/addfriend/${eeoI18nData.locale}/index.js`).then(langData => {
    eeoI18nData.messages[eeoI18nData.locale] = langData.default
    const eeoI18n = new VueI18n(eeoI18nData)
    Vue.t = function() {
      return eeoI18n.t.apply(eeoI18n, arguments)
    }
    GET_serverTime('get').then(function(res){
      var serverTime = res.data.serverTime;
      var serverDTime = new Date().valueOf()-serverTime;
      window.AppRoot = new Vue({
        i18n:eeoI18n,
        render: (h) => h(App),
        data() {
          return {
            serverDTime,
            localTime: new Date().valueOf(),
            qs,
            loading: false,
            globalData:{
              localeLangType:localeLangType
            },
          };
        },
        computed:{
          serverShowTime(){
            return this.localTime - this.serverDTime
          },
        },
        methods: {
        },
        mounted() {
          setInterval(_=>{
            this.localTime = new Date().valueOf()
          },1000);
          (/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener('blur', (e) => {
            ['input', 'textarea'].includes(e.target.localName) && document.body.scrollIntoView(false)
          }, true);
        }
      }).$mount('#app');
    })
  })
}
appCreate();